module.exports = "https://web-assets.ifttt.com/packs/media/docs/service_page_with_applets-da4fdb35.png";